import { useEffect, useState } from "react";
import { apiFetch, apiUrl } from "../api";

interface VerificationView {
  email_verified: boolean;
  sms_verified: boolean;
  verified_at: string | null;
  channel: "email" | "sms" | null;
  destination: string | null;
  activities: Array<{
    activity_id: string;
    subject: string;
    html_content: string;
    created_at: string;
    template_id: string;
  }>;
}

export function VerificationPane({ contactId, email }: { contactId: string; email: string }) {
  const [view, setView] = useState<VerificationView | null>(null);
  const [error, setError] = useState("");
  const [openId, setOpenId] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setView(null);
    setError("");
    const query = email ? `?email=${encodeURIComponent(email)}` : "";
    void apiFetch(apiUrl(`/api/contacts/${encodeURIComponent(contactId)}/verification${query}`))
      .then(async (response) => {
        if (!response.ok) throw new Error("Verification status is unavailable.");
        return (await response.json()) as VerificationView;
      })
      .then((body) => {
        if (!cancelled) setView(body);
      })
      .catch((reason: unknown) => {
        if (!cancelled) setError(reason instanceof Error ? reason.message : "Verification status is unavailable.");
      });
    return () => {
      cancelled = true;
    };
  }, [contactId, email]);

  if (error) return <p className="err">{error}</p>;
  if (!view) return <p className="muted">Loading verification…</p>;

  const verified = view.email_verified || view.sms_verified;
  return (
    <section className="contact-activity-pane">
      <h3 className="contact-history-heading">Verification</h3>
      {verified ? (
        <p>
          {view.channel === "sms" ? "SMS" : "Email"} verified for {view.destination}
          {view.verified_at ? ` on ${new Date(view.verified_at).toLocaleString()}` : ""}.
        </p>
      ) : (
        <p>Not verified yet.</p>
      )}
      {!view.activities.length ? <p className="muted">No verification email stored.</p> : null}
      {view.activities.map((activity) => (
        <article key={activity.activity_id} className="company-list">
          <button type="button" className="tab" onClick={() => setOpenId(openId === activity.activity_id ? null : activity.activity_id)}>
            {activity.subject || "Verification email"} · {new Date(activity.created_at).toLocaleString()}
          </button>
          {openId === activity.activity_id ? (
            <iframe title={activity.subject || "Verification email"} sandbox="" srcDoc={activity.html_content} style={{ width: "100%", height: "24rem", marginTop: "0.5rem", border: "1px solid #cbd5e1", borderRadius: "8px" }} />
          ) : null}
        </article>
      ))}
    </section>
  );
}
